import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-root-template',
  template: '',
})
export class AppTemplateComponent {
  constructor(@Inject(DOCUMENT) protected document: Document) {
    if (window) {
      if (window.innerWidth < 1200) {
        this.closeNav();
      }
    }
  }

  ngSelectTranslate(config: NgSelectConfig) {
    config.notFoundText = 'Geen resultaten gevonden';
    config.loadingText = 'Laden...';
    config.addTagText = 'Voeg toe';
    config.clearAllText = 'Wis alles';
  }

  sidenavToggler() {
    let sidenavShow = this.document.getElementsByClassName('g-sidenav-show')[0];
    if (!sidenavShow.classList.contains('g-sidenav-hidden')) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    let sidenavShow = this.document.getElementsByClassName('g-sidenav-show')[0];
    let toggleNavbarMinimize = this.document.getElementById('navbarMinimize');
    sidenavShow.classList.remove('g-sidenav-hidden');
    sidenavShow.classList.add('g-sidenav-pinned');
    if (toggleNavbarMinimize) {
      toggleNavbarMinimize.click();
      toggleNavbarMinimize.removeAttribute('checked');
    }
  }

  closeNav() {
    let sidenavShow = this.document.getElementsByClassName('g-sidenav-show')[0];
    let toggleNavbarMinimize = this.document.getElementById('navbarMinimize');
    sidenavShow.classList.remove('g-sidenav-pinned');
    sidenavShow.classList.add('g-sidenav-hidden');
    if (toggleNavbarMinimize) {
      toggleNavbarMinimize.click();
      toggleNavbarMinimize.setAttribute('checked', 'true');
    }
  }

  closeNavIfOpen() {
    if (window && window.innerWidth < 1200) {
      let sidenavShow = this.document.getElementsByClassName('g-sidenav-show')[0];
      let toggleNavbarMinimize = this.document.getElementById('navbarMinimize');
      if (sidenavShow.classList.contains('g-sidenav-pinned')) {
        sidenavShow.classList.remove('g-sidenav-pinned');
        sidenavShow.classList.add('g-sidenav-hidden');
        if (toggleNavbarMinimize) {
          toggleNavbarMinimize.click();
          toggleNavbarMinimize.setAttribute('checked', 'true');
        }
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    let sidenavShow = this.document.getElementsByClassName('g-sidenav-show')[0];

    if (window) {
      if (window.innerWidth > 1200) {
        if (sidenavShow.classList.contains('g-sidenav-hidden')) {
          this.openNav();
        }
      } else {
        if (!sidenavShow.classList.contains('g-sidenav-hidden')) {
          this.closeNav();
        }
      }
    }
  }
}
